/**
 * Zustand store for user profile and settings
 */

import { create } from 'zustand';
import type { UserProfile, UserSettings } from '../types';
import { DEFAULT_ALERT_THRESHOLD_MICRO_SV } from '../constants';

interface UserStore {
  profile: UserProfile | null;
  settings: UserSettings;
  setProfile: (profile: UserProfile | null) => void;
  setAlertThreshold: (microSv: number) => void;
  setNotificationsEnabled: (enabled: boolean) => void;
}

const defaultSettings: UserSettings = {
  alertThresholdMicroSv: DEFAULT_ALERT_THRESHOLD_MICRO_SV,
  notificationsEnabled: true,
};

export const useUserStore = create<UserStore>((set) => ({
  profile: null,
  settings: defaultSettings,
  setProfile: (profile) => set({ profile }),
  setAlertThreshold: (alertThresholdMicroSv) =>
    set((s) => ({ settings: { ...s.settings, alertThresholdMicroSv } })),
  setNotificationsEnabled: (notificationsEnabled) =>
    set((s) => ({ settings: { ...s.settings, notificationsEnabled } })),
}));
